import { useState } from "react";
import { useEntity, EditDialog, Field } from "./components/crud";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Pencil, Plus, X } from "lucide-react";

const BLANK = { name: "", units: [], sort: 0 };

export default function ResourcesPage() {
  const { items, save } = useEntity("resource-groups");
  const [draft, setDraft] = useState(null);
  const [newUnit, setNewUnit] = useState("");
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  return (
    <div data-testid="admin-resources-page">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">Resources</h1>
        <Button data-testid="add-resource-group-btn" onClick={() => { setDraft({ ...BLANK, sort: items.length + 1 }); setNewUnit(""); }}>
          <Plus size={16} className="mr-1" /> Add group
        </Button>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((g) => (
          <div key={g.id} className="bg-white border rounded-lg p-4">
            <div className="flex justify-between items-center mb-3">
              <p className="font-medium text-sm">{g.name} <span className="text-muted-foreground">({g.units.length} units)</span></p>
              <Button variant="ghost" size="icon" data-testid={`edit-group-${g.id}`} onClick={() => { setDraft(g); setNewUnit(""); }}><Pencil size={14} /></Button>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {g.units.map((u, i) => (
                <span key={i} className={`text-xs px-2 py-1 rounded border ${u.active ? "bg-stone-50" : "bg-stone-200 text-stone-500 line-through"}`}>{u.name}</span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {draft && (
        <EditDialog open title={draft.id ? "Edit group" : "New group"} onClose={() => setDraft(null)}
          onSave={async () => (await save(draft)) && setDraft(null)}>
          <Field label="Group name"><Input data-testid="group-name-input" value={draft.name} onChange={(e) => set("name", e.target.value)} /></Field>
          <Field label="Units">
            <div className="space-y-2">
              {draft.units.map((u, i) => (
                <div key={i} className="flex items-center gap-2">
                  <Input value={u.name} onChange={(e) => {
                    const units = [...draft.units];
                    units[i] = { ...u, name: e.target.value };
                    set("units", units);
                  }} />
                  <label className="text-xs flex items-center gap-1 whitespace-nowrap">
                    <input type="checkbox" checked={u.active} onChange={(e) => {
                      const units = [...draft.units];
                      units[i] = { ...u, active: e.target.checked };
                      set("units", units);
                    }} /> active
                  </label>
                  <Button variant="ghost" size="icon" data-testid={`remove-unit-${i}`} onClick={() => set("units", draft.units.filter((_, j) => j !== i))}><X size={14} /></Button>
                </div>
              ))}
              <div className="flex gap-2">
                <Input data-testid="new-unit-input" placeholder="New unit name" value={newUnit} onChange={(e) => setNewUnit(e.target.value)} />
                <Button variant="outline" data-testid="add-unit-btn" onClick={() => {
                  if (!newUnit.trim()) return;
                  set("units", [...draft.units, { name: newUnit.trim(), active: true }]);
                  setNewUnit("");
                }}>Add</Button>
              </div>
            </div>
          </Field>
          <Field label="Sort"><Input type="number" className="w-24" value={draft.sort} onChange={(e) => set("sort", Number(e.target.value))} /></Field>
        </EditDialog>
      )}
    </div>
  );
}
